import { BaseElement } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';

/** 图形的数据模型，封装了元数据 */
export class ShapeModel {
  element: BaseElement;
  isCollapse: boolean;
  compartments: Array<Array<BaseElement>>;

  /**
   * 构造图形的数据模型
   * @param element 元数据
   * @param isCollapse 是否收缩（仅针对于分区图形）
   */
  constructor(element: BaseElement, isCollapse: boolean) {
    this.element = element;
    this.isCollapse = isCollapse;
    this.compartments = new Array<Array<BaseElement>>();
  }

  addCompartment(compartment: Array<BaseElement>) {
    this.compartments.push(compartment);
  }
}
